import { makeStyles } from '@mui/styles'
import { Theme } from 'src/components/UI'

export default makeStyles((theme: Theme) => ({
  title: {
    fontSize: '16px !important',
    fontWeight: 500,
    lineHeight: '24px !important',
  }
}))